import type { IconSize } from '@tpg/grammar-web';
import type { IconConstant } from '@tpg/grammar-web-icons';

export interface GrammarBadgeProps {
  type?: GrammarBadgeType;
  emphasis?:
    | 'no-background'
    | 'no-background-high'
    | 'stroke'
    | 'default'
    | 'medium'
    | 'high'
    | 'hud';
  size?: 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  topLabel?: string;
  bottomLabel?: string;
  leftLabel?: string;
  label?: string;
  secondaryLabel?: string;
  mediaElevation?: boolean;
  leadingIconTemplate?: IconConstant | '';
  topIconTemplate?: IconConstant | '';
  trailingIconTemplate?: IconConstant | '';
  fullWidth?: boolean;
}

export interface GrammarTertiaryButtonProps {
  size?: 'small' | 'regular';
  label?: string;
  ariaLabel?: string;
  disabled?: boolean;
  iconTemplate?: IconConstant | '';
  iconPosition?: 'leading' | 'trailing' | 'top';
  iconOnlySize?: IconSize;
}

export interface TpgWorkflowToastProps {
  isOpen?: boolean;
  duration?: number;
  position?: string;
  isQueued?: boolean;
}

export type GrammarBadgeType
  = | 'ghost'
    | 'not-classified'
    | 'classified'
    | 'neutral'
    | 'dynamic'
    | 'accent'
    | 'ok'
    | 'error'
    | 'warning'
    | 'danger';

export type GrammarMessageStatusBarMessageStatus = 'received' | 'sending' | 'delivered' | 'error' | 'no-message';
export type GrammarModalHeaderHeadingPlacement = 'center' | 'left';
export type GrammarPrimaryButtonType = 'default' | 'error' | 'danger';
export type GrammarFABType = 'default' | 'error';
export type GrammarFABToggleType = 'default' | 'error';
export type GrammarTextAreaType = 'default' | 'error' | 'warning' | 'danger';

export enum GrammarToastType {
  ToastMessage = 'toast-message',
  WorkflowToast = 'workflow-toast',
}
